module.exports = __webpack_public_path__ + "static/media/basics_hb.5856161c.mp4";